import { create } from "zustand";

interface ChatUiState {
  isOpen: boolean;
  conversaId: string | null;
  abrir: (conversaId?: string) => void;
  fechar: () => void;
  abrirConversa: (id: string) => void;
  voltarParaLista: () => void;
}

export const useChatUiStore = create<ChatUiState>((set) => ({
  isOpen: false,
  conversaId: null,
  abrir: (conversaId) => set({ isOpen: true, conversaId: conversaId || null }),
  fechar: () => set({ isOpen: false }),
  abrirConversa: (id) => set({ isOpen: true, conversaId: id }),
  voltarParaLista: () => set({ conversaId: null }),
}));
